<template>
    <div class="h-screen flex break-words bg-white overflow-hidden">
        <router-view></router-view>
    </div>
</template>